import React from "react";
import propTypes from "prop-types";
import { Link } from "react-router-dom";

const Navbar = (props) => {
  return (

      <nav  className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}  >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            {props.title}
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
            </ul>

            <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'} `}>
                <input className="form-check-input" type="checkbox" onClick={props.toggleMode} role="switch" id="flexSwitchCheckDefault" />
                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Dark Mode</label>
            </div>

          </div>
        </div>
      </nav>
 
  );
};

Navbar.prototypes = {
  title: propTypes.string.isRequired,
  aboutus: propTypes.string.isRequired,
};
Navbar.defaultProps = {
  title: "Docket",
  aboutus: "About",
};

export default Navbar;
